<template>
    <div class="flex flex-col items-center justify-center gap-8 px-4 py-8">
        <h3 class="w-full text-center text-2xl lg:w-auto">
            {{ designPriceProduct.productTypeQuestion }}
        </h3>
        <div class="lg:px-6">
            <div
                class="mt-4 grid grid-cols-2 gap-4 xs:grid-cols-2 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-2"
            >
                <ConfiguratorButtonImage
                    v-for="selection in productOptions"
                    :key="selection.value"
                    :clickable-when-disabled="true"
                    :errored="false"
                    :image-url="getProductTypeImage(selection.value)"
                    :label="selection.label"
                    :name="selection.value"
                    :selected="false"
                    :use-story-blok-image="true"
                    height-class="h-[130px] md:h-[200px] lg:h-[280px]"
                    width-class="w-[130px] md:w-[200px] lg:w-[280px]"
                    @click="$router.push(selection.routerValue)"
                />
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { DesignPriceProductType } from '@/types/DesignPriceType';
import ConfiguratorButtonImage from '~/components/configurator/ConfiguratorButtonImage.vue';
import { productOptions } from '~/utils/designprice';

const props = defineProps<{
    designPriceProduct: DesignPriceProductType;
}>();

const getProductTypeImage = (productType: string) => {
    if (productType === 'sticker') {
        return props.designPriceProduct.stickersAndLabelsImage.filename;
    } else if (productType === 'package') {
        return props.designPriceProduct.packageImage.filename;
    }
};
</script>
